import DeleteBaseCommand from "./deleteBaseCommand";

class DeleteTemplateComponentCommand extends DeleteBaseCommand {
  constructor(componentData) {
    super(componentData);
    this.componentData = componentData;
  }

  execute() {
    super.execute();
  }

  undo() {
    super.undo();
  }
}

export default DeleteTemplateComponentCommand;
